export const TopWave = () => {
  return (
    <img
      src="/img/wave.svg"
      alt="Ola superior"
      className="user-select-none topWave"
    />
  );
};
